import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { StyledMember, StyledPanel } from '../stylesheets/styles';
import { API_URL } from '../common/constants';
import BgComponent from '../components/BgComponent';
import AuthContext from '../contexts/AuthContext';
import ModalContext from '../contexts/ModalContext';
import { isEmpty } from 'lodash';
import { StyledItem } from '../stylesheets/styles';

const Item = ({ battery }) => {
  const {id, startsFrom, endTo, name, serialNo, bindingDate, loss, pay, memo } = battery;
  
  if (isEmpty(battery)) { return null; }
  return (
    <StyledItem className='item-wrap payment-item'>
      <div className="item px-0 d-block d-lg-flex">
        {/* <div className='item-name col'>{name}</div> */}
        <div className='item-serialNo'>
          <span className='d-lg-none'>電池序號：</span>
          {serialNo}
        </div>
        {/* <div className='item-bindingDate'>{bindingDate ? new Date(bindingDate).toLocaleDateString() : '未綁定'}</div> */}
        <div className='item-starts'>
          <span className='d-lg-none'>購買日期：</span>
          {startsFrom ? new Date(startsFrom).toLocaleDateString() : '--'}
        </div>
        <div className='item-endTo'>
          <span className='d-lg-none'>到期日期：</span>
          {endTo ? new Date(endTo).toLocaleDateString() : '--'}
        </div>
        <div className='item-loss'>
          <span className='d-lg-none'>掛失：</span>
          {loss ? '是' : <span className='text-muted'>否</span>}
        </div>
        <div className='item-pay'>
          {pay ?
            <div className='text-success'>已付款</div>
            :
            (memo && memo.trim() !== '' ?
              <div className='text-muted'>{memo}</div>
              :
              <Link className='btn btn-outline-primary btn-sm' to={{
                pathname: `/payment/${id}`,
                search: `?serialNo=${serialNo}`
              }}>前往付款</Link>
            )
          }
        </div>
      </div>
    </StyledItem>
  );
}

const Batteries = () => {
  const { isAuth } = useContext(AuthContext);
  const { handleShow } = useContext(ModalContext);
  const [battery, setBattery] = useState([]);

  useEffect(() => {
    const fetchBattery = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          console.error('No token found');
          handleShow();
          return;
        }

        const response = await axios.get(`${API_URL}/api/battery`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (response.status === 401 || response.status === 500) {
          handleShow();
          return;
        }
  
        if (response.status === 200 && response.data.isSuccess) {
          setBattery(response.data.result);
        }
        
      } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 500)) {
          handleShow();
        } else {
          console.error('Error fetching battery:', error);
        }
      }
    };
  
    if (isAuth) {
      fetchBattery();
    }
  }, [isAuth]);

  return (
    <StyledMember className='register'>
      <div className='member-wrap'>
        <Container>
          <Row className="justify-content-md-center">
            <Col md="12">
              <StyledPanel>
                <div className="hgroup">
                  <h1 className="text-center">我的電池列表</h1>
                </div>
                <StyledItem className='item-wrap item-header d-none d-lg-flex'>
                  {/* <div className='item-name col'>名稱</div> */}
                  <div className='item-serialNo col'>電池序號</div>
                  {/* <div className='item-bindingDate col'>綁定時間</div> */}
                  <div className='item-starts col'>購買日期</div>
                  <div className='item-endTo col'>到期日期</div>
                  <div className='item-loss col'>掛失</div>
                  <div className='item-pay col'>付費</div>
                </StyledItem>
                {battery.map(battery => (
                  <Item key={battery.id} battery={battery} />
                ))}
              </StyledPanel>
            </Col>
          </Row>
        </Container>
        <BgComponent/>
      </div>
    </StyledMember>
  );
};

export default Batteries;